import { BoxProps, Box, styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { AmountFragment } from "src/graphql/generated/types";
import { formatAmount, getAmountColorKey } from "src/utils";

import { Card } from "../Card";

interface Props extends BoxProps {
  currentBalance: AmountFragment;
  projectedBalance: AmountFragment;
  isLandlord?: boolean;
}

const StyledCard = styled(Card)`
  ${(props) => props.theme.breakpoints.down("sm")} {
    border-bottom: ${rem(1)} solid ${(props) => props.theme.palette.gray.background};
  }
`;

const Balance = styled("p")`
  font-weight: 500;
  margin: 0;

  ${(props) => props.theme.breakpoints.down("sm")} {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

const BalanceTitle = styled("span")`
  font-size: ${rem(16)};
  color: ${(props) => props.theme.palette.text.primary};
`;

const BalanceAmount = styled("span")<AmountFragment>`
  font-size: ${rem(22)};
  font-weight: bold;
  color: ${({ value, theme }) => {
    const colorKey = getAmountColorKey(value);
    if (colorKey === "amountColor.positive") return theme.palette.amountColor.positive;
    if (colorKey === "amountColor.negative") return theme.palette.amountColor.negative;
    return undefined;
  }};

  ${(props) => props.theme.breakpoints.down("sm")} {
    font-size: ${rem(22)};
    line-height: 30px;
    margin-top: ${rem(4)};
  }
`;

export const CardBalances = ({
  currentBalance,
  projectedBalance,
  isLandlord,
  ...boxProps
}: Props) => {
  return (
    <StyledCard {...boxProps}>
      <Balance>
        <BalanceTitle>Solde actuel : </BalanceTitle>
        <BalanceAmount {...currentBalance}>{formatAmount(currentBalance)}</BalanceAmount>
      </Balance>
      {(currentBalance.value !== projectedBalance.value ||
        currentBalance.currency !== projectedBalance.currency) && (
        <Balance>
          {isLandlord ? "Réserve pour dépenses à venir : " : "Solde à venir : "}
          <Box
            component="span"
            sx={projectedBalance.value < 0 ? { color: "amountColor.negative" } : undefined}
          >
            {formatAmount(projectedBalance)}
          </Box>
        </Balance>
      )}
    </StyledCard>
  );
};
